class POITypes {
	static Invalid = 0;
	static Trigger = 100;
	static FadeIn = 101;
	static FadeOut = 102;
	static Segue = 103;
	static EarlySegue = 104;
	static Intro = 106;
	static Pitchless = 109;
	static Pitched = 110;
	static AutoGeneratedAutoFade = 200;
	static AutoGeneratedEndOfMarkup = 201;
	static AutoGeneratedGain = 202;
	static StartLiveShow = 209;
	static EndLiveShow = 210;
	static User = 1000;
}

export default POITypes;